/**
 * Pure variant resolvers for the Orders branching page.
 *
 * Mirrors `@ordo/access/nav-branching.ts:ordersVariants()` client-side
 * for switcher rendering. Lives in its own module so unit tests can
 * import without pulling the React/Vite alias dependency graph in.
 *
 * The server stays authoritative for route-level guards; these
 * helpers are presentation-only.
 */

export type OrdersVariant = 'family' | 'school' | 'kitchen'

/**
 * Resolve which Orders variants this user has access to. Ordo staff
 * (`profile.isOrdoStaff`, the full panopticon) gets all three regardless of which other
 * memberships they hold.
 */
export function resolveAvailableVariants(profileCodes: readonly string[], isOrdoStaff = false): OrdersVariant[] {
  const out: OrdersVariant[] = []
  const isOrdoAdmin = isOrdoStaff
  if (
    isOrdoAdmin ||
    profileCodes.includes('PARENT') ||
    profileCodes.includes('TEACHER') ||
    profileCodes.includes('STUDENT')
  ) {
    out.push('family')
  }
  if (isOrdoAdmin || profileCodes.includes('SCHOOL_ADMIN')) {
    out.push('school')
  }
  if (
    isOrdoAdmin ||
    profileCodes.includes('CHEF_ADMIN') ||
    profileCodes.includes('SUPPLIER_ADMIN') ||
    profileCodes.includes('CHEF_STAFF') ||
    profileCodes.includes('SUPPLIER_STAFF')
  ) {
    out.push('kitchen')
  }
  return out
}
